<template>
    <nav>
        <ul class="pagination justify-content-center">
            <template v-if="pagination.page > 3">
                <li class="page-item">
                    <a class="page-link" @click="pagination.page = 1" href="javascript:void(0)">1</a>
                </li>
                <li class="page-item disabled">
                    <span class="page-link">&hellip;</span>
                </li>
            </template>

            <li v-if="pagination.page > 2" class="page-item">
                <a class="page-link" @click="pagination.page -= 2" href="javascript:void(0)">{{ pagination.page - 2 }}</a>
            </li>
            <li v-if="pagination.page > 1" class="page-item">
                <a class="page-link" @click="pagination.page -= 1" href="javascript:void(0)">{{ pagination.page - 1 }}</a>
            </li>

            <li class="page-item active">
                <span class="page-link">{{ pagination.page }}</span>
            </li>

            <li v-if="(pagination.page + 1) <= Math.ceil(pagination.totalItems / pagination.perPage)" class="page-item">
                <a class="page-link" @click="pagination.page += 1" href="javascript:void(0)">{{ pagination.page + 1 }}</a>
            </li>

            <li v-if="(pagination.page + 2) <= Math.ceil(pagination.totalItems / pagination.perPage)" class="page-item">
                <a class="page-link" @click="pagination.page += 2" href="javascript:void(0)">{{ pagination.page + 2 }}</a>
            </li>

            <template v-if="(pagination.page + 3) <= Math.ceil(pagination.totalItems / pagination.perPage)">
                <li class="page-item disabled">
                    <span class="page-link">&hellip;</span>
                </li>
                <li class="page-item">
                    <a class="page-link" @click="pagination.page = Math.ceil(pagination.totalItems / pagination.perPage)" href="javascript:void(0)">{{ Math.ceil(pagination.totalItems / pagination.perPage) }}</a>
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'Pagination',
    props: ['pagination']
}
</script>

<style lang="sass">
</style>
